<template>
    <div class="container-fluid" v-if="employee">
        <div class="row">
            <div class="col-md-6">
                <h3 class="title">{{ employee.name }}</h3>
            </div>
            <div class="col-md-6">
                <button v-if="!employee.is_active" class="btn btn-danger btn-sm" type="button" @click="deleteEmployee(employee)" style="float: right;" title="btn btn-success btn-sm">Eliminar</button>
                <button v-if="!employee.is_active" class="btn btn-info btn-sm" type="button" @click="restoreEmployee(employee)" title="btn btn-success btn-sm" style="float: right; margin-right: 10px;">Reactivar</button>
                <button v-if="employee.is_active" class="btn btn-danger btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target=".disable-employee-modal">Dar de Baja</button>
                <button v-if="employee.is_active" class="btn btn-info btn-sm" type="button" @click="loadEmployee(employee)" title="btn btn-success btn-sm" style="float: right; margin-right: 10px;" data-bs-toggle="modal" data-bs-target=".employee-contract-modal">Ver Contrato</button>
                <button v-if="employee.is_active" class="btn btn-warning btn-sm" type="button" @click="loadEmployee(employee)" title="btn btn-success btn-sm" style="float: right; margin-right: 10px;" data-bs-toggle="modal" data-bs-target=".employee-documents-modal">Ver Documentos</button>
                <button v-if="employee.is_active" class="btn btn-success btn-sm" type="button" @click="loadSendEmployee(employee)" title="btn btn-success btn-sm" style="float: right; margin-right: 10px;" data-bs-toggle="modal" data-bs-target=".employee-send-contract-modal">Enviar Contrato</button>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-xl-12">
                <div class="card" v-bind:class="!employee.is_active ? 'ribbon-wrapper-right' : ''">
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab" id="top-tab" role="tablist">
                            <li class="nav-item"><a @click="tab = 'general'" class="nav-link active" id="general-tab" data-bs-toggle="tab" href="#top-general" role="tab" aria-controls="top-general-tab" aria-selected="true"><i class="icofont icofont-ui-home"></i>General</a></li>
                            <li class="nav-item"><a @click="tab = 'contract'" class="nav-link" id="contract-tab" data-bs-toggle="tab" href="#top-contract" role="tab" aria-controls="top-contract-tab" aria-selected="false"><i class="icofont icofont-contacts"></i>Contrato</a></li>
                            <li class="nav-item"><a @click="tab = 'vacations'" class="nav-link" id="vacations-tab" data-bs-toggle="tab" href="#top-vacations" role="tab" aria-controls="top-vacations-tab" aria-selected="false"><i class="icofont icofont-calendar"></i>Vacaciones</a></li>
                            <li class="nav-item"><a @click="tab = 'salary'" class="nav-link" id="wage-tab" data-bs-toggle="tab" href="#top-wage" role="tab" aria-controls="top-wage-tab" aria-selected="false"><i class="icofont icofont-man-in-glasses"></i>Nómina</a></li>
                        </ul>
                        <div class="tab-content" id="top-tabContent">
                            <div class="tab-pane fade show active" id="top-general" role="tabpanel" aria-labelledby="top-general">
                                <EmployeeGeneralTab ref="generalTab" @refresh="refreshEmployee" />
                            </div>
                            <div class="tab-pane fade" id="top-contract" role="tabpanel" aria-labelledby="top-contract-tab">
                                <EmployeeContractTab ref="contractTab" @refresh="refreshEmployee" />
                            </div>
                            <div class="tab-pane fade" id="top-vacations" role="tabpanel" aria-labelledby="top-vacations-tab">
                                <EmployeeVacationsTab ref="vacationsTab" @refresh="refreshEmployee" />
                            </div>
                            <div class="tab-pane fade" id="top-wage" role="tabpanel" aria-labelledby="top-wage-tab">
                                <EmployeeSalaryTab ref="salaryTab" @refresh="refreshEmployee" @tabulator="changeTabulator" @imss="changeImss" />
                            </div>
                        </div>
                        <div class="ribbon ribbon-bookmark ribbon-right ribbon-danger" v-if="!employee.is_active">BAJA:  {{ $formatDate(employee.final_date) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="tab == 'salary'">
            <div class="col-xl-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-5">
                                <span style="font-size: 14px; font-weight: bold;">Calculo de I.S.R.</span>
                                <br />
                                <br />
                                Sueldo Diario (SD): <b><span style="float: right;">{{ tabulator.daily_salary.toFixed(2) }}</span><br /></b>
                                Sueldo Mensual (SM): <span style="float: right;">{{ tabulator.month_salary.toFixed(4) }}</span><br />
                                <hr />
                                Límite Inferior (LI): <span style="float: right;">{{ tabulator.li.toFixed(4) }}</span><br />
                                Límite Superior (LS): <span style="float: right;">{{ tabulator.ls.toFixed(4) }}</span><br />
                                Cuota Fija (CF): <span style="float: right;">{{ tabulator.cuota.toFixed(4) }}</span><br />
                                Porcentaje (%): <span style="float: right;">{{ tabulator.rate }}%</span><br />
                                Excedente (E) = (SM - LI): <span style="float: right;">{{ tabulator.excedente.toFixed(4)}}</span><br />
                                Cuota Excedente (CE) = (E * %): <span style="float: right;">{{ (tabulator.excedente * 10.88 / 100).toFixed(4)}}</span><br />
                                <hr />
                                I.S.P.T. (CF + CE): <span style="float: right;">{{ tabulator.ispt.toFixed(4) }}</span><br />
                                Subsidio Mensual (SUB): <span style="float: right;">{{ tabulator.month_subsidio.toFixed(4) }}</span><br />
                                I.S.R. Mensual (ISPT - SUB): <span style="float: right;">{{ tabulator.month_isr.toFixed(4) }}</span><br />
                                I.S.R. Diario (ISR-M / 30.4): <span style="float: right;">{{ tabulator.daily_isr.toFixed(4) }}</span><br />
                                <hr />
                                I.S.R. Final (ISR-D * {{ employee.total_work_days }} días): <b><span style="float: right;">{{ (tabulator.daily_isr * employee.total_work_days).toFixed(2) }}</span><br /></b>
                            </div>
                            <div class="col-md-2"></div>
                            <div class="col-md-5">
                                <span style="font-size: 14px; font-weight: bold;">Calculo de I.M.S.S.</span>
                                <br />
                                <br />
                                Sueldo Diario (SD): <b><span style="float: right;">{{ imss.daily_salary.toFixed(2) }}</span><br /></b>
                                Salario Diario Integrado (SDI) (SD * FI): <b><span style="float: right;">{{ imss.integral_daily_salary.toFixed(2) }}</span><br /></b>
                                <hr />
                                Antigüedad: <span style="float: right;">{{ imss.work_age }} año(s)</span><br />
                                Factor de Integración (FI): <span style="float: right;">{{ imss.integration_factor.toFixed(4) }}</span><br />
                                <hr />
                                Enfermedades y Maternidad (EM) (SDI * 0.0025 * {{ employee.total_work_days }} días): <span style="float: right;">{{ (imss.integral_daily_salary * 0.0025 * imss.total_work_days).toFixed(4) }}</span><br />
                                Gastos médicos pensionados (GMP) (SDI * 0.00375 * {{ employee.total_work_days }} días): <span style="float: right;">{{ (imss.integral_daily_salary * 0.00375 * imss.total_work_days).toFixed(4) }}</span><br />
                                Invalidez y Vida (IV) (SDI * 0.00625 * {{ employee.total_work_days }} días): <span style="float: right;">{{ (imss.integral_daily_salary * 0.00625 * imss.total_work_days).toFixed(4) }}</span><br />
                                Cesantía en Edad Avanzada y Vejez (RCV) (SDI * 0.01125 * {{ employee.total_work_days }} días): <span style="float: right;">{{ (imss.integral_daily_salary * 0.01125 * imss.total_work_days).toFixed(4) }}</span><br />
                                <hr />
                                I.M.S.S (EM + GMP + IV + RCV): <b><span style="float: right;">{{ (imss.integral_daily_salary * (0.0025 + 0.00375 + 0.00625 + 0.01125) * imss.total_work_days).toFixed(2) }}</span><br /></b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="tab != 'vacations'" class="row" style="margin-top: -20px; padding-bottom: 15px;">
            <div class="col-md-12">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="sendForm()">Guardar</button>
            </div>
        </div>
        <div class="modal fade disable-employee-modal" @refresh="refreshEmployee" tabindex="-1" role="dialog" aria-labelledby="disableEmployeeModalLabel"aria-hidden="true">
            <DisableEmployeModal :employee="employee" @refresh="loadEmployee" />
        </div>
        <div class="modal fade employee-contract-modal" tabindex="-1" role="dialog" aria-labelledby="contractEmployeeModalLabel" aria-hidden="true">
            <EmployeeContractModal ref="employeeContractModal"/>
        </div>
        <div class="modal fade employee-documents-modal" tabindex="-1" role="dialog" aria-labelledby="documentsEmployeeModalLabel" aria-hidden="true">
            <EmployeeDocumentsModal ref="employeeDocumentsModal"/>
        </div>
        <div class="modal fade employee-send-contract-modal" tabindex="-1" role="dialog" aria-labelledby="sendContractEmployeeModalLabel" aria-hidden="true">
            <EmployeeSendContractModal ref="employeeSendContractModal"/>
        </div>
    </div>
</template>
<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import DisableEmployeModal from "@/components/tmkt/employees/disable_employee_modal.vue"
import EmployeeContractModal from "@/components/tmkt/employees/employee_contract_modal.vue"
import EmployeeDocumentsModal from "@/components/tmkt/employees/employee_documents_modal.vue"
import EmployeeSendContractModal from "@/components/tmkt/employees/employee_send_contract_modal.vue"
import EmployeeGeneralTab from "@/components/tmkt/employees/employee_general_tab.vue"
import EmployeeContractTab from "@/components/tmkt/employees/employee_contract_tab.vue"
import EmployeeVacationsTab from "@/components/tmkt/employees/employee_vacations_tab.vue"
import EmployeeSalaryTab from "@/components/tmkt/employees/employee_salary_tab.vue"

import validations from "@/mixins/validations/employeeValidations"

import ws from '@/services/employees'
export default {
    name: 'employee',
    mixins: [validations],
    components: {
        Datepicker,
        DisableEmployeModal,
        EmployeeContractModal,
        EmployeeDocumentsModal,
        EmployeeGeneralTab,
        EmployeeContractTab,
        EmployeeVacationsTab,
        EmployeeSalaryTab,
        EmployeeSendContractModal
    },
    data(){
        return{
            id: 0,
            employee: null,
            tabulator: null,
            imss: null,
            job_positions: [],
            employers: [],
            bosses: [],
            banks: [],
            collaborators: [],
            tab: 'general'
        }
    },
    beforeMount: async function() {
        this.id = await this.$route.params.id;

        let response = await ws.getEmployee(this.id); 

        if(response.type == "success"){
            this.employee = response.data;
        }
        else{
            window.location.href = "/panel/employees"; return;
        }

        let response2 = await ws.getPositions(); 

        if(response2.type == "success"){
            this.job_positions = response2.data;
        }

        let response3 = await ws.getEmployers(); 

        if(response3.type == "success"){
            this.employers = response3.data;
        }

        let response4 = await ws.getBosses(); 

        if(response4.type == "success"){
            this.bosses = response4.data;
        }

        let response6 = await ws.getBanks(); 

        if(response6.type == "success"){
            this.banks = response6.data;
        }

        this.setForm(this.employee);
        this.$refs.generalTab.loadEmployee(this.employee);
        this.$refs.contractTab.loadEmployee(this.employee); 
        this.$refs.salaryTab.loadEmployee(this.employee);
        this.$refs.vacationsTab.loadEmployee(this.employee);
    },
    methods: {
        sendForm(){
            if(this.tab == 'general'){
                this.$refs.generalTab.validations();
            }

            if(this.tab == 'contract'){
                this.$refs.contractTab.validations();
            }

            if(this.tab == 'salary'){
                this.$refs.salaryTab.validations();
            }
        },
        loadSendEmployee(employee){
            this.$refs.employeeSendContractModal.loadEmployee(employee);
        },
        loadEmployee(employee){
            this.employee = employee;
            this.$refs.employeeContractModal.loadEmployee(employee);
        },
        async updateEmployee(form) {
            let response = await ws.updateEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async restoreEmployee(form) {
            let response = await ws.restoreEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.employee = response.data;

                this.setForm(this.employee);
                this.$refs.generalTab.loadEmployee(this.employee);
                this.$refs.contractTab.loadEmployee(this.employee); 
                this.$refs.salaryTab.loadEmployee(this.employee);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async deleteEmployee(form) {
            let response = await ws.deleteEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                window.location.href = "/panel/employees"; return;
            }
            else{
                this.$toast.error(response.message);
            }
        },
        refreshEmployee(employee){
            this.employee = employee;

            this.setForm(this.employee);
            this.$refs.generalTab.loadEmployee(this.employee);
            this.$refs.contractTab.loadEmployee(this.employee); 
            this.$refs.salaryTab.loadEmployee(this.employee);
        },
        changeTabulator(tabulator){
            this.tabulator = tabulator;
        },
        changeImss(imss){
            this.imss = imss;
        }
    },
}
</script>

<style scoped>
    .container-fluid {
        padding-top: 20px;
    }

    .title{
        font-size: 28px;
    }

    .datepicker-here{
        padding: 0.25rem 0.75rem;
    }

    .rest_days{
        margin-left: 10px;
        float: right;
    }

    .rest_days td{
        padding-right: 8px;
        text-align: center;
    }

    .infonavit td{
        text-align: center;
    }
</style>